import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "rightbar-bottom" }
const _hoisted_2 = {
  key: 0,
  class: "actions"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.item.suggestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.suggestions, (sg, idx) => {
            return (_openBlock(), _createBlock(_component_Tooltip, {
              key: idx,
              text: sg.chat_query.title
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "action pointer",
                  onClick: $event => ($options.onSuggestion(sg))
                }, [
                  _createVNode(_component_Icon, {
                    stroke: "var(--brand-700)",
                    class: "icon",
                    icon: "spark-1",
                    size: "1.1rem"
                  }),
                  _createElementVNode("span", null, _toDisplayString(sg.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_3)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_Button, {
      class: "chat-button",
      gap: "1rem",
      primary: "",
      onClick: $options.onChat
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Icon, {
          stroke: "var(--base-white)",
          class: "icon",
          icon: "spark-1",
          size: "1.8rem"
        }),
        _createTextVNode(" " + _toDisplayString($options.action_title), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ]))
}